// import Aroplane from '../images/plane22.png' 
import Aroplane from '../images/aerolpaneFly.png'

var canvas = "";
var ctx = "";
let startX = 0;
let startY = 500;
const targetEndX = 300;
const targetEndY = 50;
const steps = 200;
const duration = 4000;
let multiplier = 1;
let animationStarted = false;
let startTime = null;
let loopStartTime = null;

let crashed = false;
var crashProgressThreshold = 0;


const img = new Image();
img.src = Aroplane; // Ensure this exists
// img.height= "180";
img.width = "40";
export function idlePlane() {
  //img.onload = () => {
  //requestAnimationFrame(animate);
  drawIdlePlane();
  //};
}

export function planeCrash() {
  return crashed;
}

export function callChart() {
  //img.onload = () => {
  if (!animationStarted) {
    setTimeout(function () {
      animationStarted = true;
    }, 900);
    startTime = null;
    loopStartTime = null;
    crashed = false;

    // Start from bottom-left corner
    startX = 0;
    startY = canvas.height - img.height / 20;

    requestAnimationFrame(animate);

  }
  //};
}

function drawIdlePlane() {
  // setTimeout(function () {
  canvas = document.getElementById("myCanvasPalne");
  ctx = canvas?.getContext("2d");
  ctx?.clearRect(0, 0, canvas.width, canvas.height);
  const idleX = 0;
  const idleY = canvas.height - img.height / 2;
  ctx.drawImage(img, idleX, idleY - img.height / 2);
  // }, 510);
}

export function setCrashTime(ctime) {
  crashProgressThreshold = ctime;
}

function easeInCirc(t) {
  //return 1 - Math.sqrt(1 - t * t);
  return 1 - Math.sqrt(1 - t);
}

function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function drawCurve(animatedEndX, animatedEndY) {
  if (!animationStarted) return;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const halfImgW = img.width / 2;
  const halfImgH = img.height / 2;

  const clampedX = clamp(animatedEndX, halfImgW, canvas.width - halfImgW);
  const clampedY = clamp(animatedEndY, halfImgH, canvas.height - halfImgH);

  // If the plane would go off canvas, skip drawing
  if (clampedX < 0 || clampedX > canvas.width || clampedY < 0 || clampedY > canvas.height) return;

  const path = new Path2D();
  path.moveTo(startX, startY);

  for (let i = 1; i <= steps; i++) {
    const t = i / steps;
    const ease = easeInCirc(t);
    const x = startX + (clampedX - startX) * t;
    const y = startY + (clampedY - startY) * ease;
    path.lineTo(x, y);
  }

  path.lineTo(clampedX, canvas.height);
  path.lineTo(startX, canvas.height);
  path.closePath();

  ctx.save();
  ctx.clip(path);
  ctx.fillStyle = "#5E808D";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
  ctx.beginPath();
  ctx.moveTo(startX, startY);

  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    const ease = easeInCirc(t);
    const x = startX + (clampedX - startX) * t;
    const y = startY + (clampedY - startY) * ease;
    ctx.lineTo(x, y);
  }

  ctx.strokeStyle = "rgb(111 178 233 / 90%)";
  ctx.lineWidth = 1;
  ctx.stroke();

  ctx.drawImage(img, clampedX - halfImgW, clampedY - halfImgH);
  ctx.font = "bold 70px system-ui";
  ctx.fillStyle = "#ffffff";
  ctx.textAlign = "center";
  // ctx.fillText(`${multiplier.toFixed(2)}x`, canvas.width / 2, canvas.height / 2);
  let elm = document.getElementById('currentMultiplier');

  if (elm) {
    //document.getElementById("currentMultiplier").textContent = `${multiplier.toFixed(2)}x`;
  }
}


let multi = 1;
function animate(timestamp) {
 
  if (!startTime) startTime = timestamp;
  const elapsed = timestamp - startTime;
  const rawProgress = Math.min(elapsed / duration, 1);
  const easedProgress = easeInOutQuad(rawProgress);

  const animatedEndX = startX + (targetEndX - startX) * easedProgress;
  const animatedEndY = startY + (targetEndY - startY) * easedProgress;

  if (!crashed) {
    setTimeout(function () {
      multiplier = 1 + elapsed / 10000;
    }, 900);
  }

  drawCurve(animatedEndX, animatedEndY, easedProgress);

  if (crashed) {
    
    showCrashEffect(animatedEndX, animatedEndY); // 💥 trigger crash
    return; // stop the animation here
  }

  if (!crashed && rawProgress < 1) {
    requestAnimationFrame(animate);
  } else {
    multi = multiplier;
    loopEndPoint(timestamp);
  }
}

export function setCrashed(status){
  crashed = status;
}
function loopEndPoint(timestamp) {

  if (!loopStartTime) loopStartTime = timestamp;
  const loopElapsed = timestamp - loopStartTime;
  // if (multi === undefined) {
  // setTimeout(function () {
  multiplier = multi + loopElapsed / 10000;
  // }, 900);

  // }else{
  //   multiplier = 1 + loopElapsed / 1000;
  // }

  // Use a single sine wave to move both diagonally
  const oscillation = Math.sin(loopElapsed / 1000); // You can tweak the speed here

  // Multiply same direction for diagonal motion
  const oscillatedEndY = clamp(targetEndY + 200 * oscillation, 0, canvas.height);
  const oscillatedEndX = clamp(targetEndX + 50 * oscillation, 0, canvas.width);

  drawCurve(oscillatedEndX, oscillatedEndY);

  if (crashed ) {
    // crashed = true;
    showCrashEffect(oscillatedEndX, oscillatedEndY); // 💥 trigger crash
    return; // stop the animation here
  }

  requestAnimationFrame(loopEndPoint);
}

function showCrashEffect(x, y) {
  // ctx.save();
  // ctx.beginPath();

  // ctx.strokeStyle = "red";
  // ctx.lineWidth = 5;
  // ctx.moveTo(x - 20, y - 20);
  // ctx.lineTo(x + 20, y + 20);
  // ctx.moveTo(x + 20, y - 20);
  // ctx.lineTo(x - 20, y + 20);
  // ctx.stroke();
  // ctx.restore();

  // ctx.font = "bold 30px Arial";
  // ctx.fillStyle = "red";
  // ctx.textAlign = "center";

  // ctx.fillText("💥 Crash!", canvas.width / 2, canvas.height / 2 + 50);
  setTimeout(() => {
    animateCrashFlyAway(x, y);
    // multiplier = 1;
    // startTime = null;
    // loopStartTime = null;
    // drawCurve(0,0)
  }, 10); // delay before plane flies out

}


function animateCrashFlyAway(startX, startY) {
  let flyX = startX;
  let flyY = startY;
  let flySpeedX = 20;
  let flySpeedY = -6;

  function fly() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    flyX += flySpeedX;
    flyY += flySpeedY;

    // Draw the plane flying out
    ctx.drawImage(img, flyX - img.width / 50, flyY - img.height / 2);

    // Optional: trail effect
    ctx.font = "bold 24px Arial";
    ctx.fillStyle = "red";
    // ctx.fillText("💥", flyX, flyY + 10);

    if (
      flyX < canvas.width &&
      flyX > -img.width &&
      flyY > -img.height
    ) {
      requestAnimationFrame(fly);
    } else {
      //setTimeout(resetGame, 100); // Reset the game after flying offscreen   
      setTimeout(() => {
        resetGame();
        animationStarted = false;
      }, 100);
    }
  }

  fly();
}

function resetGame() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  startTime = null;
  loopStartTime = null;
  crashed = false;
  multiplier = 1;
}


export function currentMultiplier() {
  return multiplier.toFixed(2);
}

export function currentStatus() {
  return { is_crash: crashed, multiplier: multiplier.toFixed(2) };
}
/******************qwertyuwertyui****************/
// }, 500);

